module.exports = __webpack_public_path__ + "static/img/zonghe.6404b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/zonghe.png
// module id = N5/z
// module chunks = 1